import type { StatusDataRecord } from '#components/shared/StatusOrder.ts';

export const TourStatusData = {
    finished: {
        color: 'success',
        icon: 'ok',
        status: 'finished',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.tour.status.finished',
    },
    'in-transit': {
        color: 'info',
        icon: 'tire',
        status: 'in-transit',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.tour.status.underway',
    },
    planned: {
        color: 'default',
        icon: 'calendar',
        status: 'planned',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.tour.status.planned',
    },
    problem: {
        color: 'danger',
        icon: 'flash ',
        status: 'problem',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.tour.status.problem',
    },
    open: {
        color: 'default',
        icon: 'question',
        status: 'open',
        selected: false,
        id: 'intl-msg:ordercom-cloud-frontend.tour.status.open',
    },
} satisfies StatusDataRecord;
